export const SLICE_NAME = "attachments"; 
